import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalsComponent} from '../globals/globals.component';

@Component({
  selector: 'app-demos',
  templateUrl: './demos.component.html',
  styleUrls: ['./demos.component.css']
})
export class DemosComponent implements OnInit {
  @ViewChild('sliderFrame') iframe: ElementRef;
  
  public
  public demoRefferURL:string;

  public  getDocHeight(doc) {
    doc = doc || document;
    var body = doc.body, html = doc.documentElement;
    var height = Math.max( body.scrollHeight, body.offsetHeight, 
        html.clientHeight, html.scrollHeight, html.offsetHeight );
    return height;
};

public setIframeHeight() {
if(this.demoHeight != "0px" ) return; // if banner skip code below
var doc=window.frames['demoIframe'].contentWindow.document;
var body_ = doc.body, html_ = doc.documentElement;

var height = Math.max( body_.scrollHeight, body_.offsetHeight, html_.clientHeight, html_.scrollHeight, html_.offsetHeight );
window.frames['demoIframe'].style.height=height+"px";
//window.frames['demoIframe'].style.border = "10px solid red";

};



  private demoUrl: string;
  private demoHeight:string;
  private demoWidth:string;

  iframeHeight: string = "1000px";
  iframeWidth: string = "2000px";
  referrer:string;

  constructor(private globals: GlobalsComponent) { 
    this.demoRefferURL = globals.demoRefferURL;
    this.demoUrl = globals.demoUrl; 
    this.demoHeight=globals.demoHeight+"px";
    this.demoWidth=globals.demoWidth+"px";
  }

  ngOnInit() {
    
    //window.document.getElementById('news-ticker').style.height="200px";
  }
  ngAfterContentInit(){  
    //alert("DEMO inside ngAfterContentInit");
  }

  ngAfterContentChecked(){
   // alert("DEMO inside ngAfterContentChecked");
  }
  
  setHeight() {
    //setTimeout(this.setIframeHeight, 100);
    this.iframeHeight = this.demoHeight;
    return this.iframeHeight;
  }
  setWidth() {
    
    this.iframeWidth = this.demoWidth;
    return this.iframeWidth;
  }
  setBackgroundColor() {
    
   if(this.demoUrl.indexOf("banner")>-1) {
      return "black";
   } else {
      return "white";
   }
  
  }
  getDemoURL(){  
    return(this.demoUrl);

  }



}



// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/demos/demos.component.ts